import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Topbar.css';
import { FaBell, FaUser, FaArrowDown, FaSignOutAlt, FaCog } from 'react-icons/fa';
import { MdMenu } from 'react-icons/md';
import axios from 'axios';
import Cookies from 'js-cookie';
import API_BASE_URL from '../../../config/api';

const AnimatedGreeting = () => {
    const [messageIndex, setMessageIndex] = useState(0);
    const [fadeState, setFadeState] = useState('fade-in');
    const baseUrl = API_BASE_URL;
    
    const getTimeBasedGreeting = () => {
        const hour = new Date().getHours();
        if (hour >= 1 && hour < 12) return "Good Morning";
        if (hour >= 12 && hour < 17) return "Good Afternoon";
        return "Good Evening";
    };
    
    
    useEffect(() => {
        // Update the first greeting every minute to keep time-based greeting current
       

        // Message rotation interval
        const messageInterval = setInterval(() => {
            setFadeState('fade-out');
            
            setTimeout(() => {
                setFadeState('fade-in');
            }, 500); // Half of the total animation duration
            
        }, 6000); // Changed from 4000 to 6000 - messages stay for 6 seconds

        return () => {
            clearInterval(messageInterval);
        };
    }, []);

    
};

const Topbar = () => {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [showNotifications, setShowNotifications] = useState(false);
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [hasPendingGoals, setHasPendingGoals] = useState(false); // NEW
    const [pendingGoalsCount, setPendingGoalsCount] = useState(0); // NEW
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const profileRef = useRef(null);
    const notificationRef = useRef(null);
    const navigate = useNavigate();
    const baseUrl = API_BASE_URL;

    useEffect(() => {
        const body = document.body;
        const isMobile = window.innerWidth <= 768;

        body.classList.toggle('sidebar-mobile', isMobile);
        body.classList.toggle('sidebar-open', !isMobile && isSidebarOpen);
        body.classList.toggle('sidebar-closed', !isMobile && !isSidebarOpen);
    }, [isSidebarOpen]);

    useEffect(() => {
        // Fetch profile data from /api/users/me
        const fetchProfile = async () => {
            setLoading(true);
            setError(null);
            try {
                const token = Cookies.get('token');
                const response = await axios.get(`${baseUrl}/api/users/me`, {
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
                    },
                });
                setProfile(response.data);
            } catch (err) {
                setError(err.response?.data?.message || err.message || 'Failed to fetch profile');
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, []);

    useEffect(() => {
        // Fetch goals and check for pending status
        let intervalId;
        const fetchGoals = async () => {
            try {
                const token = Cookies.get('token');
                const response = await axios.get(`${baseUrl}/api/goals/pending/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
                    },
                });
                const goals = response.data;
                const pendingGoals = Array.isArray(goals) ? goals.filter(goal => goal.approval_status === 'pending') : [];
                setHasPendingGoals(pendingGoals.length > 0);
                setPendingGoalsCount(pendingGoals.length);
            } catch (err) {
                setHasPendingGoals(false);
                setPendingGoalsCount(0);
            }
        };
        fetchGoals();
        intervalId = setInterval(fetchGoals, 30000); // Poll every 30 seconds
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        // Close dropdowns when clicking outside
        const handleClickOutside = (event) => {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setIsProfileOpen(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLogout = () => {
        Cookies.remove('token');
        navigate('/login');
    };

    const handleSidebarToggle = () => {
        setIsSidebarOpen(prev => !prev);
        window.dispatchEvent(new Event('toggle-sidebar'));
    };

    return (
        <>
        <style>{`
        @keyframes blinker {
          50% { opacity: 0; }
        }
        `}</style>
        <div className="topbar">
            <div className="topbar-left">
                <button
                    type="button"
                    className="topbar-menu-btn"
                    onClick={handleSidebarToggle}
                    aria-label={isSidebarOpen ? 'Close sidebar' : 'Open sidebar'}
                >
                    <MdMenu />
                </button>
            </div>

            <div className="topbar-right">
                {/* Notifications */}
                <div className="notification-container" ref={notificationRef}>
                    <button 
                        className="notification-btn"
                        onClick={() => setShowNotifications(!showNotifications)}
                    >
                        <span className="notification-icon" style={{ position: 'relative' }}>
                            <FaBell />
                            {hasPendingGoals && (
                                <span className="blinking-dot" style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    width: '12px',
                                    height: '12px',
                                    background: 'red',
                                    borderRadius: '50%',
                                    animation: 'blinker 1s linear infinite',
                                    zIndex: 2
                                }}></span>
                            )}
                        </span>
                        {notifications.length > 0 && (
                            <span className="notification-badge">{notifications.length}</span>
                        )}
                    </button>

                    {showNotifications && (
                        <div className="notification-dropdown">
                            <div className="notification-header">
                                <h3>Notifications</h3>
                                
                            </div>
                           
                            {pendingGoalsCount === 0 ? (
                                <div className="no-notifications">
                                    No new notifications
                                </div>
                            ) : (
                                <div className="notification-list">
                                     {pendingGoalsCount > 0 && (
                                        <div className="pending-goals-info" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            background: '#FFF5F0',
                                            borderRadius: '8px',
                                            padding: '14px 18px',
                                            color: '#E63D10',
                                            fontWeight: 600,
                                            fontSize: '1rem',
                                            margin: '10px 0',
                                            boxShadow: '0 2px 8px rgba(230,61,16,0.07)'
                                        }}>
                                            <span style={{padding: '10px'}}>
                                                {pendingGoalsCount} goal{pendingGoalsCount > 1 ? 's' : ''} pending approval
                                            </span>
                                            <Link to="/hod/pending-goals"
                                                style={{
                                                    marginLeft: '18px',
                                                    background: '#5A9BE0',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    padding: '7px 18px',
                                                    fontWeight: 600,
                                                    fontSize: '0.95rem',
                                                    cursor: 'pointer',
                                                    boxShadow: '0 1px 4px rgba(230,61,16,0.10)',
                                                    transition: 'background 0.2s',
                                                    textDecoration: 'none',
                                                    display: 'inline-block',
                                                    textAlign: 'center',
                                                }}
                                                onMouseOver={e => e.currentTarget.style.background = '#7A6CE0'}
                                                onMouseOut={e => e.currentTarget.style.background = '#77AFE5'}
                                            >
                                                View
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* Profile */}
                <div className="profile-container" ref={profileRef}>
                    <button 
                        className="profile-btn"
                        onClick={() => setIsProfileOpen(!isProfileOpen)}
                        disabled={loading}
                    >
                        <span className="profile-avatar"><FaUser /></span>
                        
                        <span className={`dropdown-arrow ${isProfileOpen ? 'open' : ''}`}><FaArrowDown /></span>
                    </button>

                    {isProfileOpen && !loading && profile && (
                        <div className="profile-dropdown">
                            <div className="profile-header">
                                <div className="profile-info">
                                    <span className="role-badge">
                                        {loading ? 'Loading...' : error ? 'Error' : profile ? profile?.employee?.full_name : 'Unknown'}
                                    </span>
                                    <p style={{paddingTop: '10px'}}>{profile?.employee?.user?.email}</p>
                                    <span className="role-badge">{profile?.employee?.position}</span>
                                </div>
                            </div>
                            
                            <div className="profile-menu">
                                <Link to="/hod/profile" className="profile-menu-item" onClick={() => setIsProfileOpen(false)}>
                                    <span className="menu-icon"><FaUser /></span>
                                    My Profile
                                </Link>
                               
                                <button className="profile-menu-item logout" onClick={handleLogout}>
                                    <span className="menu-icon"><FaSignOutAlt /></span>
                                    Logout
                                </button>
                            </div>
                        </div>
                    )}
                    {isProfileOpen && error && (
                        <div className="profile-dropdown">
                            <div className="profile-header">
                                <div className="profile-info">
                                    <p>Error loading profile</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
        </>
    );
};

export default Topbar;
